import axios from "axios";

const tokenUrl =
  "https://jdift-applicationportal.ken42.com/api/app/azureToken";

const axiosInstance = axios.create({
  baseURL: "https://api-v2.ken42.com/jdiftprodlead",
  timeout: 15000,
});

axiosInstance.interceptors.request.use((req) => {
  const token = sessionStorage.getItem("access_token");
  req.headers.Authorization = `Bearer ${token}`;
  return req;
});

//Response interceptor for API calls
axiosInstance.interceptors.response.use(
  (resp) => {
    return resp;
  },
  async function (error) {
    console.log(error.response.status);
    var config = {
      method: "get",
      baseURL: tokenUrl,
    };
    return axios(config).then(function (response) {
      console.log(JSON.stringify(response.data.access_token));
      sessionStorage.setItem("access_token", response.data.access_token);
      error.response.config.headers[
        "Authorization"
      ] = `Bearer ${response.data.access_token}`;
      return axios(error.response.config);
    });
  }
);

const getYear = async () => {
  const path = `/batchyear`;
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
};

const getDepartment = async () => {
  const path = `/department`;
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
};

const getPrograms = async (value) => {
  const path = `/program/${value ?? ""}`;
  const res = await axiosInstance.get(path);
  return res && res.data ? res.data : null;
};

const postDetails = async (data) => {
  const path = `/lead`;
  const res = await axiosInstance.post(path, data);
  return res && res.data ? res.data : null;
};
export { getYear, getDepartment, postDetails, getPrograms };
